"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfValidateOrderForPaymentRequest = instanceOfValidateOrderForPaymentRequest;
exports.ValidateOrderForPaymentRequestFromJSON = ValidateOrderForPaymentRequestFromJSON;
exports.ValidateOrderForPaymentRequestFromJSONTyped = ValidateOrderForPaymentRequestFromJSONTyped;
exports.ValidateOrderForPaymentRequestToJSON = ValidateOrderForPaymentRequestToJSON;
exports.ValidateOrderForPaymentRequestToJSONTyped = ValidateOrderForPaymentRequestToJSONTyped;
/**
 * Check if a given object implements the ValidateOrderForPaymentRequest interface.
 */
function instanceOfValidateOrderForPaymentRequest(value) {
    return true;
}
function ValidateOrderForPaymentRequestFromJSON(json) {
    return ValidateOrderForPaymentRequestFromJSONTyped(json, false);
}
function ValidateOrderForPaymentRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderNumber': json['orderNumber'] == null ? undefined : json['orderNumber'],
    };
}
function ValidateOrderForPaymentRequestToJSON(json) {
    return ValidateOrderForPaymentRequestToJSONTyped(json, false);
}
function ValidateOrderForPaymentRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderNumber': value['orderNumber'],
    };
}
